import { DatePipe } from '@angular/common';
import { Component,HostListener, AfterViewInit, Input, OnDestroy, ChangeDetectorRef, OnInit, ElementRef, ViewChild, Injector, OnChanges, AfterViewChecked } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MapService } from 'src/app/utils/map.service';
import * as L from 'leaflet';
import 'leaflet.vectorgrid';
import { isNullOrUndefined } from 'util';
import { AlertDataService } from '../../side-bar/alert/alert-data.service';
import { AlertMapConstants, LOCATIONS_ZOOM_RANGE, VisibilityMapConstants, LOCATIONS_LATLNG, LOCATIONS_ZOOM, BASE_LAYER_LIST, COMMON_LAYER_LIST, COMPONENT_ROUTE_MAPPING, LAYER_TYPES, MAP_OPTIONS, PROJECTUUID_LATLNG } from '../../side-bar/alert/alert-gis/alert-gis.const';
import 'src/assets/js/maplibs/L.control.HtmlLegend.js';
import 'src/assets/map-control/L.Control.ZoomBar.js';
import 'src/assets/leaflet-image-transform/L.ImageTransform.js';
import 'src/assets/js/maplibs/Leaflet-WMS.js';
import { Subscription } from 'rxjs';
// import { GisToMisMapping, ProjConstants } from '../../utils/proj.constant';
import { BaselayersComponent } from '../bottom-bar/draggable/baselayers/baselayers.component';
import { environment } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AlertMapService } from '../../side-bar/alert/alert-map.service';
import { CdkDragDrop, CdkDragStart } from '@angular/cdk/drag-drop';
import { ProjConstants } from 'src/app/utils/proj.constant';

@Component({
  selector: 'app-gis-map-alert',
  templateUrl: './gis-map-alert.component.html',
  styleUrls: ['./gis-map-alert.component.scss'],
})
export class GisMapAlertComponent implements OnInit {

  basinListDropdown:any;
  playbarflag:any = true;
  htmlLegend: any = null;
  htmlNewLegend: any;
  geoJsonTileLayer: any;
  districtClickedSubscription: any;
  adminBasinSubscription: any;
  forecastLengthSubscription: any;
  toggleSubscription: any;
  imageLayer2: any;
  clipBoundary: any;
  heatMapImages: any = [];
  timeStampList: {};
  revalidateMapSubscription: any;
  selectedLocation: any;
  dataTabToggleVal: boolean = true;
  activeLayers: any = [];
  view: string;
  activeGroup: any = 'ACTUAL';
  leftSideBarSubscription: any;
  apiData: any;
  apiParams: any;
  minMax: any;
  STATENAME: any;
  serviceMap: any;
  urlParams: any;
  bottomBarComponent: any;
  legend: any=null;
  thresholdMap: object;
  initialCounter: number;
  counter: number;
  style = {
    stroke: false,
    color: '#FF0000',
    fill: true,
    fillColor: '#FF0000',
    fillOpacity: 0.4,
    opacity: 0.4
  };
  componentType: string;
  hourCounter = '';
  blockNumber = 0;
  dateBlockNumMap = {};
  playPosition = 0;
  layers: any = {
    overlaylayers: {},
    baselayers: {}
  }
  subscriptions: Subscription[] = [];
  mapobj: any;
  highlightedLayer: any;
  highlightedLayerObj={};
  heirarchyData =[];
  geoJsonOverlay: any;
  distUUID: any;
  miTanksColorMapping: any;
  miTanksCount: any;
  coordinates: string;
  elevation: string;
  paramsSubscription;
  thresholdSubscription;
  blockNumberSubscription;
  bulletinParamsSubscription;
  heatMapParamsSubscription: Subscription;
  riverFlowSubscription : any;
  miTanksEditingSubscription : any;
  pointLayerParamsSubscription : any;
  hoveringStatusSubscription : any;
  selectedPointDetailsSubscription:any;
  heatMapParams: any;
  dashboardView: any;
  spinner: boolean = false;
  htmlLegendObjects: any = [];
  stateUrlId: string;
  modalSrv: any;
  type:any
  activeSideMenu: any;
  collapsebutton: any;
  mapZoom;
  date: any;
  newsBulletinData: any;
  sidebarstatus: any;
  stationLayerActive: any=false;
  currentView: any=false;
  groupNameToBlockMap:any
  animationLayerListBasedOnView:any = []
  showComponentWisePlayBar:Object = {
    GROUNDWATER : {
      showPlayBar : false,
      checkSelectedParams : {
        timeStep : ['MONTHLY','HOURLY']
      } 
    },
    INFLOWFORECAST : {
      showPlayBar : false,
      checkSelectedParams : {}
    },
    RAINFALL : {
      showPlayBar : false,
      checkSelectedParams : {
        timeStep : ['MONTHLY','YEARLY','HOURLY']
      }    
    },
    NOWCAST : {
      showPlayBar : false,
      checkSelectedParams : {}
    },
    PROJECT : {
      showPlayBar : false,
      checkSelectedParams : {}
    },
    GROUNDWATER_WQ : {
      showPlayBar : false,
      checkSelectedParams : {
        timeStep : ['MONTHLY']
      } 
    }
  }
  currentPosition: number =0;
  isChange: boolean =false;
  inflowLocClicked : any = false;
  reportsDates : any = [];
  screenWidth : any;
  applicationName: string;
  deviceInfo: any;
  displayTime: any;

  normalLayersList : any =["Reservoirs in Normal","River Gauges in Normal","Cities in Normal"];//"AP Normal Major Reservoir Points"
  cautionLayersList : any =["Reservoirs in CautionCaution RiverGauge Points","Cities in Caution"];//"AP Caution Major Reservoir Points"
  warningLayersList : any =["Reservoirs in Warning","River Gauges in Warning", "Cities in Warning"];//"AP Warning Major Reservoir Points"
  dangerLayersList : any =["Reservoirs in Danger","River Gauges in Danger","Cities in Danger"];//"AP Danger Major Reservoir Points"
  extremeLayersList : any =["Reservoirs on Extreme Danger","River Gauges in Extreme Danger","Cities in Extreme Danger"];//"AP Extreme Danger Major Reservoir Points"
  reservoirLayerList : any =["Reservoirs","Reservoirs in Normal","Reservoirs in CautionWarning Reservoir Points","Reservoirs in Danger","Reservoirs on Extreme Danger"];
  rivergaugeLayerList : any = ["River Gauges in Normal","River Gauges in Caution","River Gauges in Warning","River Gauges in Danger","River Gauges in Extreme Danger"];
  cityLayerList : any = ["Cities in Normal","Cities in Caution","Cities in Warning","Cities in Danger","Cities in Extreme Danger"];
  mitankLayerList : any = ["MiTank District Structures Count","MiTank_Mandal_Structures Count","Mitanks Polygon"];
  normalVisible : any = false;
  cautionVisible : any = false;
  warningVisible : any = true;
  dangerVisible : any = true;
  extremeVisible : any = true;
  reservoirVisible : any = false;
  rivergaugeVisible : any = false;
  cityVisible : any = false;
  mitankVisible : any = false;
  isLayerListClick: boolean = true;
  constructor(
    private utilsService: AlertDataService,
    public mapService: MapService,
    private route: ActivatedRoute,
    private router: Router,
    private injector: Injector,
    private gisDataService: AlertMapService,
    private ngbModal: NgbModal,
    private dataService: AlertDataService,
    private toastr : ToastrService,
    private deviceService: DeviceDetectorService, 
    public datepipe: DatePipe,
    private floodForecastUtils: AlertDataService,
    ) {
     }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.screenWidth = window.innerWidth;
  }

  @Input() mapData: any;
  @Input() component: any;
  @Input() index: any;
  @Input() blocksArray: any;
  @Input() layerList: any = {};
  @Input() tableDataComponent: any;
  // @Input() sidebarComponent: any;
  @Input() otherOptions: any;
  
  public map: L.Map;
  flag = true;
  geoJsonData: any;
  playButtonDisable = true;
  labelStrings = [];
  indexForLeftPanel: any;
  citiesData: any;
  chartData: any = [];
  chartOptions: any;
  context: CanvasRenderingContext2D;
  tsArrayForPlay: any = [];
  tsLabelsArrayForPlay: any = [];
  direction: any;
  state = 'stop';
  popUpData: any = {};
  postData: any;
  bottomBarData: any;
  bottomBarColumns: any = [];
  velocityLayer;
  wmsLayerGroup;
  allLayerList: any = [];
  overlayLayerList: any = [];
  geojsonLayerList: any = [];
  wmsLayerList: any = [];
  wmsUrl: any;
  wmsLayer: any;
  value: any = 3;
  imageUrl: any;
  adminSelected: any;
  forecastLength: any;
  shortLongRange: any;
  imageBounds: any = [];
  playpause: boolean;
  startIndex = 1;
  imageLayer: any;
  showThrobber: any;
  bottomBarMenuSelectedIndex;
  styleObjforBottomBar = {};
  vectorTileLayer = {};
  marker = null;
  noData = false;
  blocks: any;
  Linechart: any;
  showBottomBar: any;
  districtClicked: object;
  particleMultiplier: any = 0.0006;
  showThrobberbottomBar = false;
  heatMapoptions = {
    opacity: 0.8,
    pane: 'heatMap',
    minZoom: 6,
    maxZoom: 15
  };
  borderBottomBarStyle = {};
  colorForBottomBar: any;
  nowForPlay: any;
  bottomBarDataWithStyle: any;
  bottomBarTableStyles: any = {};
  gradientColors: any = [];
  gradientStyles: any = {};
  heightHundred: any = {};
  gradient: any;
  blockLayer: any;
  yAxisMin: any;
  chartTableData: any;
  chartGradient: any;
  dateList: any;
  clickedLocationMarker: any;
  clickedLocationTooltip: any;
  bottomTableKeys: any = [];
  playWidth: any = 3;
  stateBoundary: any;
  basinBoundary: any;
  activeTimePeriod: any;
  params: any = null;
  deviationMapParams: any;
  highlightMarker : any;
  title;
  timer: any
  legendList : any = {};
  isPlayBarVisibile:boolean= false;
  injectedService;
  playbarZoomLevel;
  minmaxFlag: boolean = true;
  titleHeading = {

    RAINFALL: 'RAINFALL',
    ALERT : 'ALERT'
  }
  titleIcon = {
    RAINFALL: 'bi bi-cloud-rain-fill',
    INFLOWFORECAST: 'fas fa-cloud-meatball',
  }
  wfst :any;
  wfstOptions:any;
  points:any;
  wfstHistory :any;
  wfstHistoryOptions :any;
  day = String(new Date().getDate()).padStart(2, '0');
  toggleSidebarFilterStatus:boolean = false;
  hidePlayBar:any = true;
  visibiliSidebarSubscription: any;
  sidebarOpenCloseFlag: any = true;
  sidebarHoverFlag:any = false;
  metaData: any;
  layerObject : Object = {}
  blockNum:Number;

  //dpms module point info variables
  selectedPointDetails

  // Inflow Forecast Global Variables
  basinLayerList: any = [];
  selfCatchmentLayerList: any = [];
  currentDate: any;
  inflowForecastRainfallDateRanges: any;
  ifrfHeatmap: any;

  // project dasboard related variables
  selectedProjectDetails
  selectedBasin : any ;

  ngOnInit() {
    this.applicationName = this.router.url.split('/')[1];
    this.component = this.router.url.split('/')[2];
    this.deviceInfo = this.deviceService.getDeviceInfo();
    // setTimeout(() => {
      // if (this.deviceInfo['deviceType'] === 'desktop' && this.screenWidth >= 768) {        
        this.type = this.router.url.split('/')[1];
      // }
    // }, 2000);
      // this.checkIsMobileView();
    this.revalidateMap()
    this.initMap();
    console.log("Params on Init ::::",this.params)
    setTimeout(() => {
      console.log("Inside Timeout On Init ::::",this.params,this.otherOptions)
      this.subscribeEvents();
    }, 2000); 
    this.resetBaseLayers();
    this.getAndSetBaseLayers();
    this.getLastProcessedTime();
    // this.visibiliSidebarSubscription = this.utilsService.getVisibilitySidebarMenuStatus().subscribe(params => {
    //   if (params != undefined && params != null) {
    //       this.sidebarOpenCloseFlag = params;
    //       this.toggleSidebarFilterStatus = params;
    //   }
    // });
      
  }

  ngAfterViewInit(): void {
    this.revalidateMap();
    return;
  }

  // toggleNewSidebarFilterStatus()
  // {
  //   this.toggleSidebarFilterStatus = !this.toggleSidebarFilterStatus;
  //   this.rfUtils.setVisibilityNewSidebarFilterStatus(this.toggleSidebarFilterStatus);
  //   this.sidebarOpenCloseFlag = this.toggleSidebarFilterStatus;
  // }

  //PlayProgressBar Functions

  changeTimeLayers(groupName) {
        //this.counter = parseInt(groupName, 10);
        //this.hourCounter = '';
        this.blockNumber = Number(this.groupNameToBlockMap[groupName])
        this.utilsService.setBlockNumber(this.blockNumber);
        this.utilsService.setPlayButton(this.blockNumber);
        this.injectedService[this.otherOptions['changeTimeLayers']](this,groupName);
  }

  valueChanged(e) {
    this.currentPosition=this.otherOptions.playbarOptions.value;
    this.otherOptions.playbarOptions.value = e;
    let srv = this.gisDataService;
    srv[this.otherOptions.playbarOptions['valueChanged']](this,e);
    // this.showDepthClassLayer(gisMapComp.otherOptions.playbarOptions.labels[gisMapComp.otherOptions.playbarOptions.value - 1]);
  }

  toggleShow() {
  this.minmaxFlag = ! this.minmaxFlag;
  }

  onPlay() {
    this.isChange=true;
    let srv = this.gisDataService;
    srv[this.otherOptions.playbarOptions['onPlay']](this);
    // gisMapComp.otherOptions.playbarOptions.isPlay = true;
    // gisMapComp.otherOptions.playbarOptions.interval = setInterval(() => {
    //   gisMapComp.otherOptions.playbarOptions.value = gisMapComp.otherOptions.playbarOptions.value % gisMapComp.otherOptions.playbarOptions.labels.length + 1;
    // }, 4000);

    // if(this.value == this.labels.length){
    //   setTimeout(()=>{
    //     this.value = 1;
    //     this.onPlay();
    //   },4000);
    // }
  }

  onPause() {
    let srv = this.gisDataService;
    srv[this.otherOptions.playbarOptions['onPause']](this);
    // gisMapComp.otherOptions.playbarOptions.isPlay = false;
    // clearInterval(gisMapComp.otherOptions.playbarOptions.interval);
  }

  onNext(value)
  {
    this.onPause();
    this.otherOptions.playbarOptions.value = value+1;
    let srv = this.gisDataService;
    srv[this.otherOptions.playbarOptions['valueChanged']](this,value+1);
    srv['onPrevClick'](this,value,'Next');
  }

  onPrev(value)
  {
    this.onPause();
    this.otherOptions.playbarOptions.value = value-1;
    let srv = this.gisDataService;
    srv[this.otherOptions.playbarOptions['valueChanged']](this,value-1);
    srv['onPrevClick'](this,value,'Prev');
  }

  animationValueChange(e){
    this.injectedService[this.otherOptions.playbarOptions['animationValueChange']](this,e);
  }

  setValue(event)
  {
    this.onPause();
    this.otherOptions.playbarOptions.value = event;
    let srv = this.gisDataService;
    srv[this.otherOptions.playbarOptions['valueChanged']](this,event);
    srv[this.otherOptions.playbarOptions['onUserChange']](this,event);
  }

  getMapOptions() {
    let mapOptions;
    mapOptions = {
      center: LOCATIONS_LATLNG[this.params['dashboardView']],
      zoom: LOCATIONS_ZOOM[this.params['dashboardView']]
    }
    return mapOptions;
  }


  // addHeatMapLayerToMap() {
  //   this.addHeatMap(this.currentDate);
  //   this.riverFlowSubscription =  this.utilsService.getDateRangeforRiverFlow().subscribe(value => {
  //     if (!isNullOrUndefined(value)) {
  //       this.inflowForecastRainfallDateRanges = value;
  //       this.currentDate = this.utilsService.currentDayTimestep(this.inflowForecastRainfallDateRanges);
  //       if (this.currentDate = this.utilsService.currentDayTimestep(this.utilsService.getCurrentDayWithTime())) {
  //         this.addHeatMap(value);
  //       }
  //     }
  //   });
  // }
  // addHeatMap(timeStamp: any) {
  //   let cql_filter = "uuid='" + this.params.basin + "'";
  //   if(this.params['basin']=='3a7a18ff-8614-4c90-aa98-451b333df3d9')
  //    cql_filter=null;
  //   this.inflowForecastMapSrv.getLayerWithFilter(InflowForecastLayerNames.FULL_BASIN_LAYER_NAME, cql_filter).subscribe((geoData: any) => {
  //     this.inflowForecastMapSrv.getInflowForecastRainfallHeatMap(timeStamp).subscribe((data: any) => {
  //       if (Object.keys(data).length > 0) {
  //         let layerData = Object.values(data);
  //         this.ifrfHeatmap = {
  //           "heatmapData": layerData[0],
  //           "bbox": geoData['features'][0]['geometry']
  //         }
  //         if (this.ifrfHeatmap['heatmapData'])
  //           this.addHeatMapLayer();
  //       }
  //     })
  //   })
  // }
  // addHeatMapLayer(pdLayer?,bbox?) {
  //   let layerConst:any = {},bboxConst;
  //   if(this.params['component'] == 'INFLOWFORECAST'){
  //     layerConst = INFLOWFORECAST_LAYERLIST[VisibilityMapConstants.LOCATIONS.ODISHA]
  //     bboxConst = this.ifrfHeatmap;
  //   }
  //   else if(this.params['component'] == 'PROJECT'){
  //     layerConst = pdLayer;
  //     bboxConst = bbox;
  //   }
  //   let heatmapLayersBasedOnView = this.gisDataService.getApplicationBasedLayer(layerConst, LAYER_TYPES.HEATMAP_LAYER);
  //   if(this.params['component'] == 'PROJECT'){
  //     heatmapLayersBasedOnView = this.addPDSourceWiseLayers(heatmapLayersBasedOnView,this.params);
  //   }
  //   this.layers.overlaylayers = Object.assign({}, this.layers.overlaylayers, this.gisDataService.setImageLayersNew(this.map, heatmapLayersBasedOnView, this.layers.overlaylayers, bboxConst));
  //   if(this.params['component'] == 'PROJECT'){
  //   }
    
  // }

  onDragStarted(event: CdkDragStart): void {
    this.map.dragging.disable();
  }
  
  onDragDropped(event: CdkDragDrop<any>): void {
    this.map.dragging.enable();
  }
  
  revalidateMapAfterPrint() {
  let that = this;
  var afterPrint = function() {
      setTimeout(() => {
        that.revalidateMap();
      }, 1000);

  };
  if (window.matchMedia) {
      var mediaQueryList = window.matchMedia('print');
      mediaQueryList.addListener(function(mql) {
          if (!mql.matches) {
            afterPrint();
          }
      });
  }
  window.onafterprint = afterPrint;
};

  resetVectorTileLayer(vectorTileLayer,obj){
    for(let element of obj){
      let bUUID = element['uuid'], clr = element['clr'], wt = element['wt'], opacity = element['opacity'] ? element['opacity'] : 0.85;
      if (vectorTileLayer) {
        vectorTileLayer.resetFeatureStyle(bUUID);
      }
    }
  }


  manageLegend() {
   
    if (this.otherOptions && !this.floodForecastUtils.isEmptyObj(this.otherOptions.legend))
      this.otherOptions.legend = {};
    for (const key in this.activeLayers) {
      let layer = this.layers.overlaylayers[key];
      if (layer) {
        if (!isNullOrUndefined(layer['options']['hasLegend']) || !isNullOrUndefined(layer['options']['legendName'])) {
          if (this.activeLayers[key]) {
            this.otherOptions.legend[layer['options']['legendName']] = this.legendList[layer['options']['legendName']];
          }
          else {
            for (const i in this.legendList) {
              var isInflowpoints=false;
              if (i == layer['options']['legendName']) {
                delete this.otherOptions.legend[i];
              }
            }
          }
        }
      }
    }
    for(const key in this.layers.baselayers)
    {
      let layer=this.layers.baselayers[key];
      if(layer)
      {
        if (!isNullOrUndefined(layer['options']['hasLegend']) || !isNullOrUndefined(layer['options']['legendName'])) {
          if (this.layers.baselayers[key].options.visible) {
            this.otherOptions.legend[layer['options']['legendName']] = this.legendList[layer['options']['legendName']];
            
          }
          else {
            for (const i in this.legendList) {
              if (i == layer['options']['legendName']) {
                delete this.otherOptions.legend[i];
              }
            }
          }
        }
      }
    }
    this.addLegend();

  }

  // getTitleforMap(params) {
  //   this.title = this.vservice.getTitleForComponent(params['component'], params);
  // }

  addSrcWiseWMSLayers(wmsLayersBasedOnView) {
    this.layers.overlaylayers = Object.assign({}, this.layers.overlaylayers, this.gisDataService.setWMSOverlays(this.map, wmsLayersBasedOnView, this.layers.overlaylayers));
  }
  addSrcWiseGeoportalWMSLayers(wmsLayersBasedOnView) {
    this.layers.specificlayers = Object.assign({}, this.layers.specificlayers, this.gisDataService.setWMSOverlays(this.map, wmsLayersBasedOnView, this.layers.specificlayers));
  }
  addSrcWiseTileLayers(tileLayersBasedOnView) {
    this.layers.specificlayers = Object.assign({}, this.layers.specificlayers,tileLayersBasedOnView );
  }
  addSrcWiseVECTORLayers(vectorLayersBasedOnView) {
    this.layers.overlaylayers = Object.assign({}, this.layers.overlaylayers, this.gisDataService.setVECTOROverlays(this.map, vectorLayersBasedOnView, null, this.layers.overlaylayers, this.params));
  }

  addSrcWiseGEOJSONLayers(geoJsonLayersBasedOnView) {
    this.gisDataService.setGEOJSONOverlays(this.map, geoJsonLayersBasedOnView, this.layers, this.otherOptions,this).then(data => {
      this.layers.overlaylayers = Object.assign({}, this.layers.overlaylayers, data);
      this.manageLegend();
      if(this.otherOptions && this.otherOptions['onGeoJsonEnd'] && this.injectedService){
        this.injectedService[this.otherOptions['onGeoJsonEnd']](this);
      }
    })
  }

  addSrcWiseCLUSTERLayers(clusterLayersBasedOnView){
    this.gisDataService.setCLUSTEROverlays(this.map, clusterLayersBasedOnView, this.layers, this.otherOptions,this).then(data => {
      this.layers.overlaylayers = Object.assign({}, this.layers.overlaylayers, data);
      this.manageLegend();
    })
  }

  addSrcWiseHeatmapLayers(heatMapLayersBasedOnView) {
    this.layers.overlaylayers = Object.assign({}, this.layers.overlaylayers, this.gisDataService.setImageLayers(this.map, heatMapLayersBasedOnView, this.layers.overlaylayers));
  }

  addSrcWiseHeatmapLayersInflowforecast(heatMapLayersBasedOnView) {
    this.layers.overlaylayers = Object.assign({}, this.layers.overlaylayers, this.gisDataService.setImageLayersInflowForecast(this.map, heatMapLayersBasedOnView, this.layers.overlaylayers));
  }

  getPlaybarOption()
  {
    if(this.showComponentWisePlayBar.hasOwnProperty(this.params['component'])){
      let checkParamObj = this.showComponentWisePlayBar[this.params['component']]['checkSelectedParams']
      let prev:boolean = true;
      if(!this.floodForecastUtils.isEmptyObj(checkParamObj)){
        for(let i in checkParamObj){
          if(this.params.hasOwnProperty(i)){
            let result = checkParamObj[i].includes(this.params[i])
            prev = prev && result
          }
          if(!prev){
            return prev
          }
        }
        return prev;
      }
      else{
        return true;
      }
    }
    else{
      return false;
    }
  }

  colorVectortileslayer(vectorTileLayer, obj) {
    obj.forEach(element => {
      let bUUID = element['uuid'], clr = element['clr'], wt = element['wt'], opacity = element['opacity'] ? element['opacity'] : 0.85;
      if (vectorTileLayer) {
        if (element['type']) {
          vectorTileLayer.setFeatureStyle(bUUID, {
            opacity: opacity,
            color: '#000000',
            weight: wt
          })
        }
        else {
          if(vectorTileLayer.options.name=="TN Taluk Boundaries")
            {
              vectorTileLayer.setFeatureStyle(bUUID, {
                opacity: 0.4,
                color: '#000000',
                fill: true,
                fillOpacity: 1,
                fillColor: clr,
                weight: 2
              })
            }
            else{
              vectorTileLayer.setFeatureStyle(bUUID, {
                opacity: opacity,
                color: '#000000',
                fill: true,
                fillOpacity: 1,
                fillColor: clr,
                weight: wt
              })
            }
         
        }
      }
    });
  }

  addCommonViewLayers(layerList, params) {
    let layers = {};
    for (let layerName in layerList) {
      if ((layerList[layerName].layerOptions['view'] ==VisibilityMapConstants.VIEWS.ALL) ||
        (layerList[layerName].layerOptions['dashboardView'] && layerList[layerName].layerOptions['dashboardView'] == params['dashboardView']
          && layerList[layerName].layerOptions['view'] == params['view'])) {
        layers[layerName] = layerList[layerName];
        this.activeLayers[layerName] = layerList[layerName].layerOptions.visible;
      }
    }
    return layers;
  }

  removeHighlightedLayers(params){
    for (let locType in this.highlightedLayerObj) {
      this.map.removeLayer(this.highlightedLayerObj[locType]);
      delete this.highlightedLayerObj[locType];
    }
  }

  getLocationAndAPIMapping(params){
    let locTypeMapping = {
      [VisibilityMapConstants.LOCATIONS.DISTRICT]: {
        url: 'AP_DISTRICTS',
        uuidColName: 'uuid',
        zoomLevel: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.BLOCK].MIN,
        pane: 'state'
      },
      [VisibilityMapConstants.LOCATIONS.BLOCK]: {
        url: 'AP_MANDAL',
        uuidColName: 'uuid',
        zoomLevel: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.MITANK].MIN + 1,
        pane: 'district'
      },
      [VisibilityMapConstants.LOCATIONS.BASIN]: {
        url: 'AP_BASIN',
        uuidColName: 'uuid',
        zoomLevel: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.SUBBASIN].MIN,
        pane: 'state'
      },
      [VisibilityMapConstants.LOCATIONS.SUBBASIN]: {
        url: 'AP_SUBBASIN',
        uuidColName: 'uuid',
        zoomLevel: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.BASIN_LAST_LEVEL].MIN,
        pane: 'district'
      },
      // [VisibilityMapConstants.LOCATIONS.COMMAND_AREA]: {
      //   url: 'kwaram_command_area',
      //   uuidColName: 'cmduid',
      //   zoomLevel: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.COMMAND_AREA].MAX,
      //   pane: 'state'
      // },
      // [VisibilityMapConstants.LOCATIONS.SUB_COMMAND_AREA]: {
      //   url: 'kwaram_sub_command_area',
      //   uuidColName: 'scmduid',
      //   zoomLevel: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.SUB_COMMAND_AREA].MIN,
      //   pane: 'state'
      // },
      // [VisibilityMapConstants.LOCATIONS.COMMAND_DISTRICT]: {
      //   url: 'kwaram_command_district',
      //   uuidColName: 'cmddistuid',
      //   zoomLevel: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.COMMAND_DISTRICT].MAX-1,
      //   pane: 'state'
      // },
      //  [VisibilityMapConstants.LOCATIONS.COMMAND_MANDAL]: {
      //   url: 'kwaram_command_mandal',
      //   uuidColName: 'cmdmanduid',
      //   zoomLevel: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.MITANK].MIN + 1,
      //   pane: 'district'
      // },
      // [VisibilityMapConstants.LOCATIONS.VILLAGE]: {
      //   url: 'tamilnadu_villages',
      //   uuidColName: 'uuid',
      //   zoomLevel: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.VILLAGE].MIN + 2,
      //   pane: 'state'
      // },
    };
    return locTypeMapping;
  }

  async getHierachyData(params){
    let postData={}
    postData = this.dataService.getPostDataForBreadCrumb(params);
    this.heirarchyData = [];
    this.spinner = true;
    // let data = await this.dataService.post(VisibilityMapConstants.API_MAPPING.BREADCRUMB, postData,params).toPromise();
    let data : any = [{
      "ln": "ANDHRAPRADESH",
      "lUUID": "6f86292b-dd9a-4987-bb8f-c3940263b349",
      "locType": "STATE"
    }]
    if(data && data.length>0){
      this.heirarchyData = data;
    }
    this.spinner = false;
  }

  async setGeoJsonFeaturesOnClick(params) {
    // this.removeHighlightedLayers(params);
    let mapOptions = this.getMapOptions();
    if (params['pType'] == VisibilityMapConstants.LOCATIONS.STATE ) {
      this.map.setView([mapOptions.center[0], mapOptions.center[1]], mapOptions.zoom);
      this.mapZoom = mapOptions.zoom;
      return;
    }
    let locTypeMapping = this.getLocationAndAPIMapping(params);
    for(let index=0;index< this.heirarchyData.length;){
      let locObj = this.heirarchyData[index];
      if(locTypeMapping[locObj['locType']] != undefined){
        // if (params['view'] == 'COMBINED_BASIN') {
        //   locTypeMapping[locObj['locType']].url = InflowForecastLayerNames.FULL_BASIN_LAYER_NAME;
        // }
        let response = await this.getHighlightedLayer(locTypeMapping,locObj,params);
        if((params['dashboardView'] == 'TN_BASIN_VIEW' && params['component'] == 'RAINFALL') ||(params['dashboardView'] == 'TN_BASIN_VIEW' && params['component'] == 'RESERVOIR') || (params['dashboardView'] == 'TN_BASIN_VIEW' && params['component'] == 'RIVER_GAUGE')|| params['dashboardView'] == 'CROP_WATER_DEMAND'){
          this.map.fitBounds(response['geojsonLayer'].getBounds());
          this.map.addLayer(this.highlightedLayerObj[locObj['locType']]);
        }
        // if(params['dashboardView'] == 'CROP_WATER_DEMAND'){
        //   this.map.fitBounds(response['geojsonLayer'].getBounds());
        //   this.map.addLayer(this.highlightedLayerObj[locObj['locType']]);
        // }
        else if( !response['isError'] && locObj['locType'] == params['pType']) {
          let data = response['data'];
          if(data['features'] && data['features'].length>0)
            {
              this.map.setView([data['features']['0']['properties'].latitude, data['features']['0']['properties'].longitude], locTypeMapping[params['pType']].zoomLevel);
              this.map.addLayer(this.highlightedLayerObj[locObj['locType']]);
            }
        }
        else if(!response['isError'] && params['component']=='GROUNDWATER' && params['pType']=='GROUNDWATER' && (locObj['locType']=='VILLAGE'||locObj['locType']=='SUBBASIN'))
        {
          this.map.addLayer(this.highlightedLayerObj[locObj['locType']]);
        }
        else if(!response['isError']  && params['component']=='WC_STRUCTURE' && params['pType']=='WC_STRUCTURE' && (locObj['locType']=='VILLAGE'||locObj['locType']=='SUBBASIN'))
        {
          let data = response['data'];
          // this.map.setView([data['features']['0']['properties'].latitude, data['features']['0']['properties'].longitude], locTypeMapping[locObj['locType']].zoomLevel);
          this.map.addLayer(this.highlightedLayerObj[locObj['locType']]);
        }
      }
      index++;
    }
    this.mapZoom = this.map.getZoom();
  }

  getHighlightedLayer(locTypeMapping,locObj,params): Promise<any> {
    let response={
      isError : false
    };
    let styleObj =  {
      weight: ((locTypeMapping[locObj['locType']].pane =='district' && this.params['component'] =='NDVI') ? 0.8 :2.7 ),
      color: '#000000',
      fillOpacity: 0,
      pane:params['component']=='DRINKINGWATERSTRESS' || params['component']=='WATERAUDIT'||params['component']=='CROP_WATER_DEMAND'||params['component']=='VILLAGE_WB'?'marker':locTypeMapping[locObj['locType']].pane
    };
    let pUUId,filter,year='';
    if(params['component']=='GWMS')
      {
        pUUId=locObj['uuid'];
        if(params['mapid'])
          year='';
        else
         year=params['year'].split('-')[0];
         filter = locTypeMapping[locObj['locType']].uuidColName + "='" + pUUId + "'";

       
      }
    else
    {
     pUUId = locObj['lUUID'];
     filter = locTypeMapping[locObj['locType']].uuidColName + "='" + pUUId + "'";
    }
    this.spinner = true;
    let promise = new Promise((resolve, reject) => {
      this.dataService.getLayerWithFilter(locTypeMapping[locObj['locType']].url, filter,year).subscribe((data: any) => {
        this.highlightedLayerObj[locObj['locType']] = (L as any).geoJSON(data, {
          style: styleObj,
          interactive:false
        })
        response['data'] = data;
        response['geojsonLayer'] = this.highlightedLayerObj[locObj['locType']]
        this.spinner = false;
        resolve(response);
      }, err => {
        this.spinner = false;
        response.isError = true;
        reject(response);
      });
    });
    return promise
  }

  /*
   Sets Base Layer to Carto whenever a Component is Loaded
 */
  resetBaseLayers() {
    for (let layerType in BASE_LAYER_LIST) {
      for (let layer of BASE_LAYER_LIST[layerType]) {

        if(this.route.snapshot.params.component == 'mitanks' || this.route.snapshot.params.component == 'dpms'){
          if (layer['name'] == "Google Satellite") {
            layer['visible'] = true;
          } else if (layer['name'] == "Carto") {
            layer['visible'] = false;
          }
        }
        else if(this.route.snapshot.params.component == 'projectdashboard'){
          if (layer['name'] == "Bhuvan") {
            layer['visible'] = true;
          } else{
            layer['visible'] = false;
          }
        }
        else if(this.route.snapshot['_urlSegment']['segments'][1] == 'geoportal')
        {
          if(layer['name'] == 'Carto')
           layer['visible'] =true;
          else{
            layer['visible'] = false;
          }
        }
        else{
          if (layer['name'] == "Google Satellite") {
            layer['visible'] = false;
          }else if (layer['name'] == "Carto") {
            layer['visible'] = true;
          }
        }
      }
    }
  }

  getAndSetBaseLayers() {
    let tileLayers = this.gisDataService.addBaseTileLayers(BASE_LAYER_LIST[LAYER_TYPES.TILE_LAYER], this.map)
    // let wms = this.gisDataService.getApplicationBasedLayer(BASE_LAYER_LIST[LAYER_TYPES.WMS_LAYER], LAYER_TYPES.WMS_LAYER)
    this.layers.baselayers = Object.assign(tileLayers);
  }

  getAndSetCommonLayers() {
    let wmsLayersBasedOnView = this.gisDataService.getApplicationBasedLayer(COMMON_LAYER_LIST[VisibilityMapConstants.VIEWS.ALL], LAYER_TYPES.WMS_LAYER);
    wmsLayersBasedOnView = this.addCommonViewLayers(wmsLayersBasedOnView, this.params);
    this.layers.overlaylayers = Object.assign(this.layers.overlaylayers, this.gisDataService.setWMSOverlays(this.map, wmsLayersBasedOnView));
  }


  addLayersBasedOnView() {
    let wmsLayersBasedOnView = this.gisDataService.getApplicationBasedLayer(COMMON_LAYER_LIST[this.params['view']], LAYER_TYPES.WMS_LAYER);
    wmsLayersBasedOnView = this.addCommonViewLayers(wmsLayersBasedOnView, this.params);
    this.layers.overlaylayers = Object.assign(this.layers.overlaylayers, this.gisDataService.setWMSOverlays(this.map, wmsLayersBasedOnView));
    let vectorLayersBasedOnView = this.gisDataService.getApplicationBasedLayer(COMMON_LAYER_LIST[this.params['view']], LAYER_TYPES.VECTOR_LAYER, this.params);
    vectorLayersBasedOnView = this.addCommonViewLayers(vectorLayersBasedOnView, this.params);
    this.layers.overlaylayers = Object.assign(this.layers.overlaylayers, this.gisDataService.setVECTOROverlays(this.map, vectorLayersBasedOnView, null, null, this.params));
  }

  formatLayersData(layerList) {
    for (let layerName in layerList) {
      if (layerList[layerName].layerOptions.hasOwnProperty('cql_filter_value')) {
        layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + " ='" + this.params.basin + "'";
      }
      layerList[layerName].layerOptions.visible = false;
    }
    return layerList;
  }

  subscribeInterBasinEvents(){
    this.paramsSubscription = this.utilsService.selectedParams.subscribe(params => {
      if (!this.floodForecastUtils.isEmptyObj(params)) {
        let routeParams = this.floodForecastUtils.getWritableObject(this.route.snapshot.params);
        if(Object.keys(routeParams).length==0){
          routeParams = {
            component : 'interbasintransfer',
            dashboard : 'waterSupply'
          };
        }
        if(COMPONENT_ROUTE_MAPPING[params['component']] &&
         COMPONENT_ROUTE_MAPPING[params['component']]  == routeParams['component']){
          this.params = params;
          this.urlParams = params;
        }
      }
    });
  }

  subscribeEvents() {

    this.paramsSubscription = this.utilsService.selectedParams.subscribe(params => {
      console.log('Params in paramsSubscription :::',params)
      if (!this.floodForecastUtils.isEmptyObj(params)) {
        let routeParams = this.floodForecastUtils.getWritableObject(this.route.snapshot.params);
        if(Object.keys(routeParams).length==0){
        routeParams = {
          component : 'rainfall',
          dashboard : 'waterSupply',
          dashboardView : 'ANDHRAPRADESH',
          view : "BASIN",
          actionType : 'filter',
        };
      }
      if(COMPONENT_ROUTE_MAPPING[params['component']] ){
        this.params = params; 
        this.urlParams = params;
        if(this.params['component']==VisibilityMapConstants.COMPONENT.RAINFALL && params['actionType']=='filter')
           this.currentView=false
          // this.hidePlayBar = this.getPlaybarOption();
          this.initializeOnLoad();
          }
        }
    });

    this.blockNumberSubscription = this.utilsService.getBlockNumber().subscribe(no => {
      this.blockNum = no;
    }); 

    this.selectedPointDetailsSubscription = this.utilsService.getSelectedPointInfo().subscribe(pointInfo => {
      if (!this.floodForecastUtils.isEmptyObj(pointInfo)) {
        this.selectedPointDetails = pointInfo;
        // this.initializeOnLoad();
      }
    });
    this.heatMapParamsSubscription = this.utilsService.selectedHeatMap.subscribe(params => {
      if (!this.floodForecastUtils.isEmptyObj(params)) {
        this.inflowLocClicked = false;
        this.heatMapParams = null;
        let routeParams = this.floodForecastUtils.getWritableObject(this.route.snapshot.params);
        if(Object.keys(routeParams).length==0){
        routeParams = {
          component : 'rainfall',
          dashboard : 'waterSupply'
        };
      }
        if(COMPONENT_ROUTE_MAPPING[params['component']] &&
        COMPONENT_ROUTE_MAPPING[params['component']]  == routeParams['component']){
          this.heatMapParams = params;
          this.initializeOnHeatmapLoad();
        }
      }
    });
   this.pointLayerParamsSubscription = this.utilsService.getPointLayerParams().subscribe((pointParams: any) => {
      if (Object.keys(pointParams).length > 0) {
        // this.getMetaData(pointParams.basin);
        // if(this.params['component'] == VisibilityMapConstants.COMPONENT.INFLOWFORECAST && pointParams['tableClick']){
        //   this.inflowLocClicked = true;
        //   this.urlParams=pointParams;
        //   this.injectedService['tableLocClick'](this,pointParams);
        // }else{
          this.inflowLocClicked = false;
        // }
      }
    })
  }

  // getMetaData(basinUUID?: any) {
  //   let postData: any = {
  //     basinUUID: basinUUID
  //   }
  //   this.inflowForecastDataSrv.getHecHmsMetaDataForAllPoints(postData).subscribe(data => {
  //     let obj={}
  //     Object.keys(data).forEach(basin=>{
  //       Object.keys(data[basin]).forEach(key=>{
  //         obj[key]=data[basin][key];
  //       })
  //     })
  //     this.metaData=obj;
  //     // this.metaData = data;
  //   });

  // }

  setView(mapOptions) {
    this.map.setView([mapOptions.center[0], mapOptions.center[1]], mapOptions.zoom);
  }

  checkIsLastLevel() {
    let isLastLevel = false, lastIndex = this.params['locationTypeList'].length;
    lastIndex = lastIndex - 1;
    if (lastIndex > 0) {
      let lastLevel = this.params['locationTypeList'][lastIndex];
      if (lastLevel == this.params['pType']) {
        isLastLevel = true;
      }
    }
    if(isLastLevel){
      let defaultLocations =[
        VisibilityMapConstants.LOCATIONS.STATE,
        VisibilityMapConstants.LOCATIONS.BASIN,
        VisibilityMapConstants.LOCATIONS.DISTRICT,
        VisibilityMapConstants.LOCATIONS.SUBBASIN,
        VisibilityMapConstants.LOCATIONS.BLOCK,
      ]
      let index = defaultLocations.findIndex(locType=> locType == this.params['pType']);
      if(index > -1){
        isLastLevel = false;
      }

    }
    return isLastLevel;
  }

  checkCurrentLevel(){
    let valid = false;
    let index = this.params['locationTypeList'].findIndex(loc => loc == this.params['pType']);
    if (index == 0) {
      valid = true;
    } else {
      valid = false;
    }
    return valid;
  }

  async initializeOnLoad() {
    this.injectedService = this.gisDataService;
    let isLastLevel = false;//this.checkIsLastLevel();
    let currentLevel = true;//this.checkCurrentLevel();
    // this.getTitleforMap(this.params);
    this.removeHighlightedLayers(this.params);
    this.checkAndSetPlaybar();
    if(this.otherOptions && this.otherOptions['manageBaseLayersFunctionName']){
      this.injectedService[this.otherOptions['manageBaseLayersFunctionName']](this);
    }
    await this.getHierachyData(this.params);
    if (!isLastLevel) {
      // this.removeGeoJsonLayers(this.params);  // Uncomment when masking is required
      if (this.params['actionType'] == 'filter') {
        this.removeComponentWiseLayers();
        if (currentLevel) {
          this.removeAllLayers();
          let mapOptions = this.getMapOptions();
          console.log("mapOptions",mapOptions)
          if (this.map) {
            this.setView(mapOptions);
            // else if(this.params.component == 'INFLOWFORECAST') {
            //   let geoData = await this.getInflowForecastBasinData()
            //   if(geoData){
            //     this.fitMapToBasinView(geoData);
            //     this.getInflowForecastLayers()
            //   }
            // }
          }
          this.addLayersBasedOnView();
          this.getAndSetCommonLayers();
          this.coordinateReadout();
          }
      }
      this.injectedService['getSrcWiseLayers'](this);
      // play progress bar animation for RF Actual ,RF Nowcast and Inflow forecast 
      // if(this.getPlaybarOption()) // i
      // {
      //   // if(this.params['pType'] == "STATE"){
      //     this.injectedService[this.otherOptions['animateHeatMapLayers']](this);
      //     this.labelStrings = this.injectedService[this.otherOptions['getLabelStringsForPlayBarAnimation']](this);
      //     this.playButtonDisable = false;
      //   // } 
      // }
      this.manageGeoJsonLayers(this.params);
      this.setGeoJsonFeaturesOnClick(this.params);
     
    }
    else {
      if(this.params['component'] == VisibilityMapConstants.LOCATIONS.RAINFALL){
        this.injectedService['getSrcWiseLayers'](this);
      }
      this.setActiveFeatureData();
      this.setGeoJsonFeaturesOnClick(this.params);
      // this.removeGeoJsonLayers(this.params);  // Uncomment when masking is required
    }
  }

  initializeOnHeatmapLoad() {
    let srv = this.injector.get(this.gisDataService)
    srv[this.otherOptions['heatMapFunctionName']](this);  
  }

  checkAndSetPlaybar(){
    this.playbarZoomLevel = LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.MITANK].MIN;
    if(this.otherOptions && this.otherOptions['playbarOptions'] != undefined){
      if(this.otherOptions['playbarOptions'][this.params['dashboardView']] && this.otherOptions['playbarOptions'][this.params['dashboardView']][this.params['view']] )
      this.playbarZoomLevel = this.otherOptions['playbarOptions'][this.params['dashboardView']][this.params['view']];
    }
  }

  getPDMapOptions(){
    return {
      center: PROJECTUUID_LATLNG[this.params['projectUUID']],
      zoom: 9
    }
  }

  async addBaseLayerAndSetZoom() {
    let mapOptions = this.getMapOptions();
      if(this.params['basin'].ln!='All' && this.params['subbasin'].ln=='All')
          {
          }
          else if(this.params['basin'].ln!='All' && this.params['subbasin'].ln!='All')
          {
          }
     else if(this.params['basin'].ln =='All' && this.params['subbasin'].ln=='All'){
      if (this.map) {
        this.setView(mapOptions);
        }
     }
  }

  manageGeoJsonLayers(params) {
    // let that = this;
    this.map.on({
      zoomend: (e: L.LeafletEvent) => {
        // that.mapZoom = e['sourceTarget']['_zoom'];
        this.mapZoom = this.map.getZoom();
        if (this.layers && this.layers['overlaylayers']) {
          Object.keys(this.layers['overlaylayers']).forEach(layerName => {
            if (this.layers['overlaylayers'][layerName]['options'] && this.layers['overlaylayers'][layerName]['options']['type'] == LAYER_TYPES.GEOJSON_LAYER) {
              if (this.layers['overlaylayers'][layerName]['options'] && ((this.layers['overlaylayers'][layerName]['options']['view'] === params['view']) || (this.layers['overlaylayers'][layerName]['options']['view'] ==VisibilityMapConstants.VIEWS.ALL))) {
                // console.log("\n  this.layers['overlaylayers'][layerName] ", this.layers['overlaylayers'][layerName]);
                let minZoom = this.layers['overlaylayers'][layerName]['options']['minZoom'],
                  maxZoom = this.layers['overlaylayers'][layerName]['options']['maxZoom'], currentZoom = this.map.getZoom();
                let bool = this.gisDataService.checkZoomlevelsForGeoJSON(this.layers['overlaylayers'][layerName]['options'],currentZoom );
                // console.log(layerName, this.layers['overlaylayers'][layerName]['options'], minZoom, maxZoom, "\n manageGeoJsonLayers \n", bool, "\n hasLayer ", this.map.hasLayer(this.layers['overlaylayers'][layerName]));
                if (bool) {
                  if (!this.map.hasLayer(this.layers['overlaylayers'][layerName])){
                    this.map.addLayer(this.layers['overlaylayers'][layerName]);
                    this.activeLayers[layerName] = true;
                  }
                } else {
                  if (this.map.hasLayer(this.layers['overlaylayers'][layerName])){
                    this.map.removeLayer(this.layers['overlaylayers'][layerName]);
                    this.activeLayers[layerName] = false;
                  }
                }
              }
              // this.addLegend();
            }
          })
        }
        if(this.otherOptions && this.otherOptions['changeLegendOnZoom'] != undefined){
          this.injectedService[this.otherOptions['changeLegendOnZoom']](this);
        }
        let valid = true;
        let index = this.params['locationTypeList'].findIndex(locType=>locType == this.params['pType']);
        if(index >0){
          valid = true;
        }else{
          valid = false;
        }
        if (valid) {
          for (let locType in this.highlightedLayerObj) {
            if (this.highlightedLayerObj[locType] != undefined) {
              let currentZoom = this.map.getZoom();
              let minZoom = LOCATIONS_ZOOM_RANGE[locType].MIN, maxZoom = LOCATIONS_ZOOM_RANGE[locType].MAX;
              // console.log("\n currentZoom ",currentZoom,"\n minZoom",minZoom,"\n maxZoom",maxZoom,"\n locType ",locType);
              if (currentZoom >= minZoom && currentZoom <= maxZoom) {
                if (!this.map.hasLayer(this.highlightedLayerObj[locType])) {
                  this.map.addLayer(this.highlightedLayerObj[locType]);
                }
              }else{
                if (this.map.hasLayer(this.highlightedLayerObj[locType])) {
                  this.map.removeLayer(this.highlightedLayerObj[locType]);
                }
              }
            }
          }
        }
      }
    })
    this.revalidateMapAfterPrint();
  }

  async initializeGeoportalOnLoad()
  {
    this.injectedService = this.gisDataService;
    this.removeHighlightedLayers(this.params);
    // if (this.params['actionType'] == 'filter') {
      this.removeComponentWiseLayers();
      this.removeAllLayers();
      let mapOptions = this.getMapOptions();
      this.setView(mapOptions);
      this.addLayersBasedOnView();
      this.getAndSetCommonLayers();
      this.coordinateReadout();
      this.injectedService['getSrcWiseLayers'](this);
       
    // }
  }

  getInflowForecastLayers(){
    this.coordinateReadout();
    this.injectedService['getSrcWiseLayers'](this);
    this.playButtonDisable = false;
    this.manageGeoJsonLayers(this.params);
    this.setGeoJsonFeaturesOnClick(this.params);
  }


  // async getInflowForecastBasinData()
  // {
  //       this.spinner = true
  //   this.removeSelectedBasin()
  //   let url = await (environment.url.NEW_GEOSERVER_URL + InflowForecastConstant.Geoserver_Workspace + InflowForecastConstant.GeoJSON_Pre_url + InflowForecastLayerNames.FULL_BASIN_LAYER_NAME + InflowForecastConstant.geoJson_post_url + "&cql_filter=uuid='" + this.params.basin + "'");
  //     if(this.params['basin']=='3a7a18ff-8614-4c90-aa98-451b333df3d9') 
  //       url = await (environment.url.NEW_GEOSERVER_URL + InflowForecastConstant.Geoserver_Workspace + InflowForecastConstant.GeoJSON_Pre_url + InflowForecastLayerNames.FULL_BASIN_LAYER_NAME + InflowForecastConstant.geoJson_post_url);
  //       let response = await this.inflowForecastMapSrv.geoJsonCall(url).toPromise();
  //   return response
  // }

   fitMapToBasinView(geoData) {
     let geoJsonData = new L.GeoJSON(geoData, {});
      this.basinLayerList.push(geoJsonData);
      this.map.fitBounds(geoJsonData.getBounds());
  }

  removeSelectedBasin() {
    if (this.basinLayerList.length > 0) {
      if (!isNullOrUndefined(this.basinLayerList)) {
        this.basinLayerList.forEach((point) => {
          if (!isNullOrUndefined(point)) {
            this.map.removeLayer(point);
          }
        });
      }
    }
  }

  setActiveFeatureData() {
    let srv = this.gisDataService;
    if (this.params['actionType'] == 'filter') {
      if(this.otherOptions['stationLayer']){
        srv[this.otherOptions['stationLayer']](this);
      }
    }
    if(this.otherOptions['stationHighlightFunctionName']){
      srv[this.otherOptions['stationHighlightFunctionName']](this);
    }
  }

  updateZoomLevel() {
    if (this.map) {
      let minZoom = MAP_OPTIONS.minZoom;
      if (LOCATIONS_ZOOM_RANGE[this.params['pType']]) {
        minZoom = LOCATIONS_ZOOM_RANGE[this.params['pType']].MIN;
      }
      this.map.setMinZoom(minZoom);
    }
  }

  ngOnChanges()
  {
    console.log('other:::',this.otherOptions,this.tableDataComponent)
    this.inflowLocClicked = false;
    
    this.paramsSubscription = this.utilsService.selectedParams.subscribe(params => {
      this.inflowLocClicked = false;
      if(!this.floodForecastUtils.isEmptyObj(params) && params['component'] &&  params['dataTabKey']){
        this.dataTabToggleVal = params['dataTabKey'];
      }
    });

  }
  getSidebarClassName(){
    if(this.otherOptions.playbarOptions && this.otherOptions.playbarOptions.showPlayBar){
      if(this.sidebarOpenCloseFlag && this.sidebarHoverFlag){
        return 'side-hover-play play-time-shrink has-play-bar';
      }else if(this.sidebarOpenCloseFlag && !this.sidebarHoverFlag){
        return 'play-time-shrink has-play-bar';
      }else if(!this.sidebarOpenCloseFlag && this.sidebarHoverFlag){
        return 'side-hover-play has-play-bar';
      }else if(!this.sidebarOpenCloseFlag && !this.sidebarHoverFlag){
        return 'has-play-bar';
      }
     }
     else if(this.hidePlayBar==true){
        if(this.sidebarOpenCloseFlag && this.sidebarHoverFlag){
          return 'side-hover-play play-time-shrink has-play-bar';
        }else if(this.sidebarOpenCloseFlag && !this.sidebarHoverFlag){
          return 'play-time-shrink has-play-bar';
        }else if(!this.sidebarOpenCloseFlag && this.sidebarHoverFlag){
          return 'side-hover-play has-play-bar';
        }else if(!this.sidebarOpenCloseFlag && !this.sidebarHoverFlag){
          return 'has-play-bar';
        }
       }


  }

  getBottombarClassName(){
    if(this.isPlayBarVisibile){
      return 'side-hover-play play-time-shrink ';
  }
}

  coordinateReadout() {
    let that = this;
    this.map.on('mousemove', function (e: L.LeafletMouseEvent) {
      that.coordinates = e.latlng.lat.toFixed(4) + ',' + e.latlng.lng.toFixed(4);
      clearTimeout(that.timer);
      that.timer = setTimeout(() => { that.dateReadOut(e.latlng)}, 1000)
    });
  }

  dateReadOut(event) {
    if(!BaselayersComponent.selectedSource){
      this.date = null;
      return;
    }
    this.layers.overlaylayers['BASELAYER_METADATA']['options']['cql_filter']="source='"+BaselayersComponent.selectedSource+"'";
    this.layers.overlaylayers['BASELAYER_METADATA']['wmsParams']['cql_filter']="source='"+BaselayersComponent.selectedSource+"'";
    this.gisDataService.getFeatureInfo(event, this.layers.overlaylayers['BASELAYER_METADATA'], this.map).subscribe((res: any) => {
      if (res && res['features'].length>=1 && res['features'][0]['properties']['latest_date'] && res['features'][0]['properties']['latest_date'].split('T').length>0) {
        this.date = res['features'][0]['properties']['latest_date'].split('T')[0];
       }else{
        this.date = null;
      }
    });
  }

  elevationReadout(event) {
    this.gisDataService.getFeatureInfo(event, this.layers.overlaylayers['SRTM_DEM_30'], this.map).subscribe((res: any) => {
      if (res && res['features'].length > 0) {
        this.elevation = res['features'][0]['properties']['GRAY_INDEX'] + 'm';
      }
    });
  }

  ngOnDestroy() {
    this.removeAllLayers()
    if (this.map && this.map.hasLayer(this.highlightedLayer))
      this.map.removeLayer(this.highlightedLayer);
    this.highlightedLayer = null
    var mapDiv = document.getElementById('mymap');
    if(mapDiv){
      mapDiv.remove();
    }
    if (this.bulletinParamsSubscription != undefined) {
      this.bulletinParamsSubscription.unsubscribe();
    }
    if (this.forecastLengthSubscription != undefined) {
      this.forecastLengthSubscription.unsubscribe();
    }
    if (this.adminBasinSubscription != undefined) {
      this.adminBasinSubscription.unsubscribe();
    }
    if (this.districtClickedSubscription != undefined) {
      this.districtClickedSubscription.unsubscribe();
    }
    if (this.leftSideBarSubscription != undefined) {
      this.leftSideBarSubscription.unsubscribe();
    }
    if (this.visibiliSidebarSubscription != undefined) {
      this.visibiliSidebarSubscription.unsubscribe();
    }
    if (this.paramsSubscription != undefined) {
      this.paramsSubscription.unsubscribe();
    }
    if (this.riverFlowSubscription != undefined) {
      this.riverFlowSubscription.unsubscribe();
    }
    if (this.heatMapParamsSubscription != undefined) {
      this.heatMapParamsSubscription.unsubscribe();
    }
    if (this.miTanksEditingSubscription != undefined) {
      this.miTanksEditingSubscription.unsubscribe();
    }
    if (this.pointLayerParamsSubscription != undefined) {
      this.pointLayerParamsSubscription.unsubscribe();
    }
    if (this.hoveringStatusSubscription != undefined) {
      this.hoveringStatusSubscription.unsubscribe();
    }
    if(!isNullOrUndefined(this.blockNumberSubscription)){
      this.blockNumberSubscription.unsubscribe();
    }
    this.dataService.setSelectedParams({})
  }

  checkIsMobileView() {
    let windowSize = window.matchMedia("(max-width:992px)");
    if (windowSize['matches']) {
      this.dataTabToggleVal = false;
      this.toggleSidebarFilterStatus = false;
    }
    else{
      // this.utilsService.setVisibilitySidebarMenuStatus(true);
      this.toggleSidebarFilterStatus = true;
    }
  }


  private initMap(): void {
    MAP_OPTIONS['editable'] = true;    
    this.map = (L.map as any)('map', MAP_OPTIONS);
    this.utilsService.setMapObj(this.map);
    this.addZoomBar();
    this.createPanes();
    this.createLegend();
    const Coordinates = L.Control.extend({
      onAdd: map => {
        const container = L.DomUtil.create("div");
        // container.className = 'latlng-mousehover';
        map.addEventListener("mousemove", e => {
          container.innerHTML = `
          <span class='latlng-mousehover'>Lat:
            ${e.latlng.lat.toFixed(
              6
            )} <br>Long:  ${e.latlng.lng.toFixed(6)}
            </span>
          `;
        });
        return container;
      }
    });
    this.map.addControl(new Coordinates({ position: "bottomleft" }));

    L.control.scale().addTo(this.map) 
    this.map.dragging.enable();

  }

  addZoomBar() {
    let zoomBarControl = new (L as any).control.zoomBar();
    zoomBarControl.addTo(this.map);
  }

  private createPanes() {
    VisibilityMapConstants.PANE_LIST.forEach(pane => {
      this.map.createPane(pane.name);
      this.map.getPane(pane.name).style.zIndex = pane.zindex;
    });
  }

  createLegend() {
    this.removeUpdatedLegend();
    // HtmlLegend HtmlLegendForVisibility
    this.htmlNewLegend = new (L as any).Control.HtmlLegendForVisibility({
      position: 'bottomright',
      collapseSimple: false,
      detectStretched: false,
      collapsedOnInit: false
    });
    if (!isNullOrUndefined(this.htmlNewLegend)) {
      this.map.addControl(this.htmlNewLegend);
    }
  }

  // createLegend() {
  //     return new(L as any).Control.HtmlLegend({
  //         position: 'bottomright',
  //         collapseSimple: false,
  //         detectStretched: false,
  //         collapsedOnInit: false
  //     });
  // }

  removeUpdatedLegend(){
    if (this.htmlNewLegend){
      this.map.removeControl(this.htmlNewLegend);
      this.htmlNewLegend.clearLegend();
    }
  }

  addLegend(){
    // this.removeUpdatedLegend();
    this.createLegend();
    let legendData;
    legendData = this.otherOptions.legend;
    let legendValue;
    for(let key in legendData){
      if (legendData[key]) {
        legendValue = this.getLegendData(legendData[key]);
        this.htmlNewLegend.addLegend(legendValue);
      }
    }
  }

// odissa legend
  getLegendData(data) {
    let legend = {
      name: `<span title="legend" ></span>`,
      elements: []
    }
    let isTrue = 1;

    if (isTrue == 1 && data.colorValues && data.colorValues.length > 0) {
      let html = ``, color;
      color = '#ffffff';
      for (let key = 0; key < data.colorValues.length; key++) {
        if (data.colorValues[key]['image']) {
          if (data.colorValues[key]['image'] === './assets/imgs/visibilityDashboards/miTanks/MITankPolygon.png') {
            html = data.HTML ? data.HTML : "<p><img src='" + data.colorValues[key]['image'] + "'/></p>";
          } 
          else {
            // html = data.HTML ? data.HTML : "<p><img  src='" + data.colorValues[key]['image'] + "'/></p>";
            html += `<div class="legend-item"><p>${data.colorValues[key].text}</p><img  src='${data.colorValues[key].image}'></div>`;
          }
        }else if(data.type && data.type == 'colorScale'){
          const ranges = data.colorValues;
              html +=
                '<p class="my-0 font-weight-bold text-center" style="background-color:' + ranges[key]['backgroundColor']
                + ' ; color:' + ranges[key]['color'] + '">' + ranges[key].text + '</p>';
        } else{
          html += `<div></span><span style='background-color: ${data.colorValues[key].backgroundColor}'></span><p>${data.colorValues[key].text}</p></div>`;
        }
      }
      legend['elements'].push({ html: html });

    } else if (data.HTML || data.image) {
      let html = data.HTML ? data.HTML : "<img src='" + data.image + "'/>";
      legend.elements.push({ html: html });
    }
    return legend;
  }

  removeLegend(){
    if (this.legend) {
      this.legend.remove();
      this.map.removeControl(this.legend);
    }
  }

  addBaseTileLayers(layerList) {
    let baselayers = {}
    for (let index in layerList) {
      let layer = layerList[index];
      let layerObj
      layerObj = this.gisDataService.addTileLayer(layer);
      if (layer['visible']) {
        this.map.addLayer(layerObj);
      }
      baselayers[layer['name']] = layerObj;
    }
    return baselayers;
  }

  revalidateMap(): void {
    window.dispatchEvent(new Event('resize'));
    if (this.map) {
      setTimeout(() => {
        this.map.invalidateSize();
      }, 200)
    }

  }
  
  openBottomBar(apiParams, bottomBarComponent) {
    this.bottomBarComponent = bottomBarComponent;
    this.showBottomBar = true;
    this.apiParams = apiParams;
  }

  removeAllLayers() {
    for (const key in this.layers.overlaylayers) {
      // if(((layer['view'] != this.params['view'] || layer['dashboardView'] != this.params['dashboardView'] )
      // && layer['view']!='ALL')){
      if (this.map.hasLayer(this.layers.overlaylayers[key])) {
        this.map.removeLayer(this.layers.overlaylayers[key]);
      }
      delete this.layers.overlaylayers[key];
    }
     this.activeLayers = [] ;
  }

  removeAdminBasinLayers(){
    for (const key in this.layers.overlaylayers) {
      let layer = this.layers.overlaylayers[key]['options'];
      if(((layer['view'] != this.params['view'] || layer['dashboardView'] != this.params['dashboardView'] )
      && layer['view']!='ALL')){
      if (this.map.hasLayer(this.layers.overlaylayers[key])) {
        this.map.removeLayer(this.layers.overlaylayers[key]);
      }
      delete this.layers.overlaylayers[key];
      delete this.activeLayers[key] ;
    }
    }
  }

  // getBasinData() {
  //   // this.serviceMap.getMetaDataForAllPoints().subscribe(data => {
  //     // this.metaData = data; // angular.fromJson(angular.toJson(data));
  //     // this.metaDataobj.basin = data;
  //     this.setBaseLayersOnMap();
  //     // this.setOverlayLayersOnMap();
  //   // });
  // }


  // setBaseLayersOnMap() {
  //   // creating the tile layers to add onto the map object
  //   this.baseLayers = this.serviceMap.createBaseTileLayers(this.otherOptions['metaData']['FloodForecastBaseLayerOptions']);
    
  //   this.layersList.baseLayers = Object.assign(this.layersList.baseLayers, this.baseLayers);
  //   // adding the base layer to map object
  //   this.serviceMap.setBaseLayer(this.baseLayers, this);
  // }

  removeFlowLabels() {
    if (this.serviceMap.labelLayerList) {
      for (const index in this.serviceMap.labelLayerList) {
        const layer = this.serviceMap.labelLayerList[index];
        if (layer == null || layer == undefined) { continue; }
        if (this.map.hasLayer(layer)) { this.map.removeLayer(layer); }
      }
    }
    this.serviceMap.labelLayerList = [];
  }


  // removeOverlayLayers() {
  //   const overlayLayers = this.layersList.overlayLayers;
  //   for (const overlay in this.layersList.overlayLayers) {
  //     const layer = overlayLayers[overlay];
  //     if (layer == null || layer == undefined) { continue; }
  //     if (this.map.hasLayer(layer)) { this.map.removeLayer(layer); }
  //   }
  // }

  // setLayersBasedOnView(layers, view) {   // for concat layer in flood forecast
  //   const viewToLayerMap = {
  //     southZone: ['South Zone', 'South Zone Inverse' , 'Tamilnadu Basin','Kerala Basin' ,'Odisha State'],
  //     // southZone: ['South Zone', 'South Zone Inverse' , 'Tamilnadu Basin','Odisha State'],
  //     ap: ['AP', 'AP Inverse'],
  //     godavariBasin: ['Godavari', 'Godavari Inverse', 'Godavari Self Catchment'],
  //     godavari_hec_hms: ['Godavari', 'Godavari Inverse', 'Godavari Self Catchment'],
  //     krishnaBasin: ['Krishna', 'Krishna Inverse'],
  //     pennarBasin: ['Pennar', 'Pennar Inverse'],
  //     vamsadharaBasin: ['Vamsadhara', 'Vamsadhara Inverse'],
  //     nagavaliBasin: ['Nagavali', 'Nagavali Inverse'],
  //     MahanadiBasin: ['Mahanadi', 'Mahanadi Inverse'],
  //     CauveryBasin: ['Cauvery'],
  //     godavariMask: ['Godavari Basin Mask Clip', 'Godavari Basin-Merge Mask Clip'],
  //     godavariTelangana: ['Godavari Telangana', 'Godavari Telangana Inverse']
  //   };
  //   for (const i in layers) {
  //     if (i) {
  //       if (viewToLayerMap[view].includes(i)) {
  //         layers[i].layerOptions.visible = true;
  //       } else {
  //         layers[i].layerOptions.visible = false;
  //       }
  //       if (this.regionSelected === 'godavariBasin') {

  //         this.map.removeLayer(this.layers.overlaylayers[key])
  //       }
  //       delete this.layers.overlaylayers[key];
  //       // delete this.activeLayers[key] ;
  //     }
  //   }
  // }

  removeComponentWiseLayers() {
    for (const key in this.layers.overlaylayers) {
      let layer = this.layers.overlaylayers[key]['options'];
      if (layer['component'] && (layer['component'] == this.params['component'])) {
        if (this.map.hasLayer(this.layers.overlaylayers[key])) {

          this.map.removeLayer(this.layers.overlaylayers[key])
        }
        delete this.layers.overlaylayers[key];
        // delete this.activeLayers[key] ;
      }
    }
  }



  addedLayer :any;
  polygonEvent:any;
  locationMetaData:any={};
  saveButtonEnabled = false;

  getConfiguredLayerForHistory(layer){
    let coordinates = [];
    let points = layer.getLatLngs();
    for (var i = 0; i < points[0][0].length; i++) {
        coordinates.push([points[0][0][i].lat, points[0][0][i].lng])
    }
    let polygonLayer = new (L as any).polygon([[coordinates]]).toGeoJSON();
    let prevLayer = L.GeoJSON.geometryToLayer(polygonLayer,null)
    polygonLayer['properties'] = {...layer['feature']['properties']}
    polygonLayer['properties']['timestamp'] =  new Date();
    prevLayer['feature'] = polygonLayer;
    return prevLayer;
  }

  // goToMISView(){
  //   //this.router.navigate(['tamilnadu', 'mis',GisToMisMapping[COMPONENT_ROUTE_MAPPING[this.params['component']]]])
  //   if (this.params.component != 'INFLOWFORECAST') {
  //     this.router.navigate(['tamilnadu', 'mis',GisToMisMapping[COMPONENT_ROUTE_MAPPING[this.params['component']]]]);

  //   } else {
  //     let mergedParams: any = {};
  //     mergedParams['basinUUID'] = this.urlParams.basin;
  //     this.router.navigate(['tamilnadu', 'mis',GisToMisMapping[COMPONENT_ROUTE_MAPPING[this.params['component']]],mergedParams]);
  //   }
  // }
  getsideBarStatus($event) {
    this.sidebarstatus = $event

  }

  onMapChange(){
      let stationLayerName=this.params['component']=='RAINFALL'?'Rainfall Sensor I':'GWQ Stations'
      let heatMapLayerName=this.params['component']=='RAINFALL'?'Rainfall Heatmap':'GroundWater quality Heatmap';
      if(this.currentView){  //for station map
        this.hidePlayBar=false;
        if(this.layers['overlaylayers'][stationLayerName]){
          this.layers['overlaylayers'][stationLayerName]['options']['visible'] =true;
          this.activeLayers[stationLayerName] = true;
          if (this.activeLayers[stationLayerName] == true) {
            this.map.addLayer(this.layers['overlaylayers'][stationLayerName])
          }
        }
        if(this.layers['overlaylayers'][heatMapLayerName]){
          this.layers['overlaylayers'][heatMapLayerName]['options']['visible'] =false;
          this.activeLayers[heatMapLayerName] = false;
          if (this.activeLayers[heatMapLayerName] == false) {
            this.map.removeLayer(this.layers['overlaylayers'][heatMapLayerName])
          }
        }
      }
      else{  // for heatmap
        this.hidePlayBar=true
        if(this.layers['overlaylayers'][heatMapLayerName]){
          this.layers['overlaylayers'][heatMapLayerName]['options']['visible'] =true;
          this.activeLayers[heatMapLayerName] = true;
          if (this.activeLayers[heatMapLayerName] == true) {
            this.map.addLayer(this.layers['overlaylayers'][heatMapLayerName])
          }
        }
        if(this.layers['overlaylayers'][stationLayerName]){
          this.layers['overlaylayers'][stationLayerName]['options']['visible'] =false;
          this.activeLayers[stationLayerName] = false;
          if (this.activeLayers[stationLayerName] == false) {
            this.map.removeLayer(this.layers['overlaylayers'][stationLayerName])
          }
        }
      }
      if(this.params['component']=='RAINFALL')
      {
        this.manageLegend();
      }
  }
  // getTooltipText(value: string): string {
  //   return this.rfUtils.getTooltipText(value)
    
  // }

    collapse(event: any) {
      this.collapsebutton = event;
    }
  
    activeMenu(event: any) {
      this.activeSideMenu = event;
    }

    dataTabToggle() {
      this.revalidateMap();
      this.dataTabToggleVal = !this.dataTabToggleVal;
      // this.utilsService.setCurrentComponent(this.router.url.split('/')[2]);
  
      if (this.dataTabToggleVal) {
        if (document.getElementById("MapContainer").offsetWidth < 1600) {
          document.documentElement.style.setProperty('--opacite', 'none');
          document.documentElement.style.setProperty('--lPercent', '70%');
        }
      } else {
        document.documentElement.style.setProperty('--opacite', 'display');
        document.documentElement.style.setProperty('--lPercent', '50%');
      }
    }


  checkISLayerApplicable(layerName){
    let layerArr = [ "Telangana Basin Depth_Class","Telangana Depth_Class","Depth_Class","Depth_Class2"], isRequired = false;
    if(layerName != undefined && layerName != null){
      let index = layerArr.findIndex(layer => layer == layerName);
      if(index>-1){
        isRequired = true;
      }
    }
    // console.log("\n In checkISLayerApplicable :: isRequired",isRequired,"\n layerName",layerName,"\n layerArr",layerArr);
    return isRequired;
  }

    showAndHideLayer(layer,base,dateChange?){
      // console.log("\n In showAndHideLayer :: gisMapComp",this.gisMapComp,"\n layer",layer,"\n this.activeLayers",this.activeLayers);
       if(base){
         for (const key in this.layers.baselayers) {
           if (this.layers.baselayers.hasOwnProperty(key)) {
             const value = this.layers.baselayers[key];
             if(this.map.hasLayer(value))
             this.map.removeLayer(value);
             value.options.visible = false;
           }
         }
         this.map.addLayer(layer);
         layer.options.visible = true;
         return;
       }
      //  if(this.params && this.params.component === 'INFLOWFORECAST' && isNullOrUndefined(layer.options)){
      //   let Options : any = {...this.inflowOptions};
      //   let selLayer : any = '';
      //   let date : any = new Date(Number(this.inflowIndex));
      //   date = this.utilsSrv.getModelDateFromDate(date);
      //   if(layer == 'heatMap'){
      //     Options['isHeatMapLayer'] = !this.inflowOptions['isHeatMapLayer'];
      //     selLayer = this.inflowIndex.toString();
      //   }else if(layer == 'point'){
      //     Options['isPointLayer'] = !this.inflowOptions['isPointLayer'];
      //     selLayer = 'Inflow_Points_'+date;
      //   }else if(layer == 'riverflow'){
      //     Options['isRiverLayer'] = !this.inflowOptions['isRiverLayer'];
      //     selLayer = 'River_Flow_'+date;
      //   }
      //   // let layers :any = Object.keys(this.layersList.overlaylayers);
      //   this.utilsSrv.setInflowOptions(Options);
      //   // let index = layers.indexOf(layer);
      //   console.log('this.layersList.overlaylayers[layer] ::',this.inflowIndex,this.layersList.overlaylayers[selLayer],'\n',this.layersList.overlaylayers,'\n',selLayer)
      //   this.showAndHideLayer(this.layersList.overlaylayers[selLayer],false);
      //   return;
      //  }
       console.log("\n In showAndHideLayer, layer",layer,"\n layer.options.key",layer.options.key);
       if(layer.options.component == "INFLOWFORECAST" && dateChange ){
         this.changeTimeLayers(Number (layer.options.groupName));
         return;
       }
       var is_deselect = false, isRequired = this.checkISLayerApplicable(layer.options.key);
       if(isRequired){
         let source =this.params['src'];
         if(layer.options.visible == true){
           if(this.injectedService){
             this.injectedService[this.otherOptions['handleLayerControlEvent']](this,layer.options.key,'remove');
           }else{
             if(source){
               this.gisDataService.handleLayerControlEvent('remove',source);
             }else{
               this.gisDataService.handleLayerControlEvent('remove');
             }
           }
           if(this.activeLayers){
             this.activeLayers[layer.options.key] = false;
           }
           layer.options.visible = false;
         }else{
           if(this.injectedService){
             this.injectedService[this.otherOptions['handleLayerControlEvent']](this,layer.options.key,'add');
           }else{
             if( source){
               this.gisDataService.handleLayerControlEvent('add',source);
               this.gisDataService.emitSourceChangeEvent(source);
             }else{
               this.gisDataService.handleLayerControlEvent('add');
             }
           }
           if(this.activeLayers){
             this.activeLayers[layer.options.key] = true;
           }
           layer.options.visible = true; 
         }
       }else{
        
         if (layer.options.key == "Telangana MiTank_Mandal_Structures Count" || layer.options.key == "Telangana MiTank_SubBasin Structures Count" || layer.options.key == "Telangana MiTank_Basin Structures Count" || layer.options.key=="Mandal Wc Structures count" || layer.options.key=="Wc Structures count" || layer.options.key=='WCS points') {
          let currentZoom = this.map.getZoom(),minZoom = layer['options']['minZoom'],maxZoom = layer['options']['maxZoom'],
          params = this.params;
          let bool = false;
          if(currentZoom>=minZoom && currentZoom<=maxZoom){
            bool = true;
          }
          // console.log("\n bool ",bool," \n layer",layer,"\n layer.options.visible)",layer.options.visible,"\n currentZoom ",currentZoom,"\n params ",params);
          if(layer.options.visible){
            if(this.map.hasLayer(layer)){
              this.map.removeLayer(layer);
            }
          }else{
            if(bool ||(
             (params['pType'] == VisibilityMapConstants.LOCATIONS.MITANK || 
              params['pType'] == VisibilityMapConstants.LOCATIONS.BLOCK ) && currentZoom>maxZoom
            )){
              if(!this.map.hasLayer(layer)){
                this.map.addLayer(layer);
              }
            }else{
  
            }
          }
          if(this.activeLayers){
            this.activeLayers[layer.options.key] = !layer.options.visible;
           }
          layer.options.visible = !layer.options.visible;
         }
         else{
          if(this.map.hasLayer(layer)){
            this.map.removeLayer(layer);
            if(this.activeLayers){
             this.activeLayers[layer.options.key] = false;
            }
            layer.options.visible = false;
            if(layer.options.hasOwnProperty('emitFromLayerControl') && layer.options.emitFromLayerControl){
              this.utilsService.setIsVisibleOfClusterLayer(false);
            }
          }else
           if (!is_deselect) {
            this.map.addLayer(layer);
            if(this.activeLayers){
             this.activeLayers[layer.options.key] = true;
            }
            layer.options.visible = true;
            if(layer.options.hasOwnProperty('emitFromLayerControl') && layer.options.emitFromLayerControl){
              this.utilsService.setIsVisibleOfClusterLayer(true);
            }
          }
         }
       }
       if(this.params && this.params['component']){
         this.manageLegend();
       }
     }

     accordianOnClick(event) {
      let target = event.target || event.srcElement || event.currentTarget;
      /* Toggle between adding and removing the "active" class,
      to highlight the button that controls the panel */
      target.classList.toggle("active");
  
      /* Toggle between hiding and showing the active panel */
      let panel = target.nextElementSibling as HTMLElement;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    }

    handleEventFromSearch(data) {
        this.map.flyTo(
          [data.location.lat, data.location.long],
          ProjConstants.LOCATION_ZOOM_MAPPING[data["et"]]
        );
        // this.utils.setMap.subscribe(map => {
        //   map.flyTo(
        //     [data.location.lat, data.location.long],
        //     ProjConstants.LOCATION_ZOOM_MAPPING[data["et"]]
        //   );
        // })
      }

      getLastProcessedTime() {
        this.dataService.getLastProcessedTime().subscribe(resp => {
          let timeStamp = Number(resp['APSDPS'])
          let date = new Date(timeStamp);    
          this.displayTime = this.datepipe.transform(date, 'dd-MMM-yyyy hh:mm a', '+0530');
        })
      }

    showHideAlertLayers(alertType : any){
      let layerArray : any = [];
      let visible : any;
      if(alertType == 'normal'){
        layerArray = this.normalLayersList;
        this.normalVisible = !this.normalVisible;
        visible = this.normalVisible;
      }else if(alertType == 'caution'){
        layerArray = this.cautionLayersList;
        this.cautionVisible = !this.cautionVisible;
        visible = this.cautionVisible;
      }else if(alertType == 'warning'){
        layerArray = this.warningLayersList;
        this.warningVisible = !this.warningVisible;
        visible = this.warningVisible;
      }else if(alertType == 'danger'){
        layerArray = this.dangerLayersList;
        this.dangerVisible = !this.dangerVisible;
        visible = this.dangerVisible;
      }else if(alertType == 'extreme'){
        layerArray = this.extremeLayersList;
        this.extremeVisible = !this.extremeVisible;
        visible = this.extremeVisible;
      }

      
      for (const key of layerArray) {
        console.log('key :::',key)
        if (this.layers.overlaylayers.hasOwnProperty(key)) {
          const layer = this.layers.overlaylayers[key];
          let is_deselect = false;
          if(this.map.hasLayer(layer) && !visible){
            this.map.removeLayer(layer);
            if(this.activeLayers){
            this.activeLayers[layer.options.key] = false;
            }
            layer.options.visible = false;
            if(layer.options.hasOwnProperty('emitFromLayerControl') && layer.options.emitFromLayerControl){
              this.utilsService.setIsVisibleOfClusterLayer(false);
            }
          }else{
            if(!is_deselect){
              this.map.addLayer(layer);
              if(this.activeLayers){
                this.activeLayers[layer.options.key] = true;
              }
              layer.options.visible = true;
              if(layer.options.hasOwnProperty('emitFromLayerControl') && layer.options.emitFromLayerControl){
                this.utilsService.setIsVisibleOfClusterLayer(true);
              }
            }
          }
        }
      }
      if(this.params && this.params['component']){
        this.manageLegend();
      }
    }

    showHideComponentLayers(type :any){
      let layerArray : any = [];
      let visible : any;
      if(type == 'reservoir'){
        layerArray = this.reservoirLayerList;
        this.reservoirVisible = !this.reservoirVisible;
        visible = this.reservoirVisible;
      }else if(type == 'rivergauge'){
        layerArray = this.rivergaugeLayerList;
        this.rivergaugeVisible = !this.rivergaugeVisible;
        visible = this.rivergaugeVisible;
      }else if(type == 'mitank'){
        layerArray = this.mitankLayerList;
        this.mitankVisible = !this.mitankVisible;
        visible = this.mitankVisible;
      }else if(type == 'city'){
        layerArray = this.cityLayerList;
        this.cityVisible = !this.cityVisible;
        visible = this.cityVisible;
      }

      
      for (const key of layerArray) {
        console.log('key :::',key)
        if (this.layers.overlaylayers.hasOwnProperty(key)) {
          const layer = this.layers.overlaylayers[key];
          let is_deselect = false;
          if(this.map.hasLayer(layer) && !visible && !this.normalVisible && layer.options.key.includes('Normal')){
            this.map.removeLayer(layer);
            if(this.activeLayers){
            this.activeLayers[layer.options.key] = false;
            }
            layer.options.visible = false;
            if(layer.options.hasOwnProperty('emitFromLayerControl') && layer.options.emitFromLayerControl){
              this.utilsService.setIsVisibleOfClusterLayer(false);
            }
          }if(this.map.hasLayer(layer) && !visible && !this.cautionVisible && layer.options.key.includes('Caution')){
            this.map.removeLayer(layer);
            if(this.activeLayers){
            this.activeLayers[layer.options.key] = false;
            }
            layer.options.visible = false;
            if(layer.options.hasOwnProperty('emitFromLayerControl') && layer.options.emitFromLayerControl){
              this.utilsService.setIsVisibleOfClusterLayer(false);
            }
          }if(this.map.hasLayer(layer) && !visible && !this.warningVisible && layer.options.key.includes('Warning')){
            this.map.removeLayer(layer);
            if(this.activeLayers){
            this.activeLayers[layer.options.key] = false;
            }
            layer.options.visible = false;
            if(layer.options.hasOwnProperty('emitFromLayerControl') && layer.options.emitFromLayerControl){
              this.utilsService.setIsVisibleOfClusterLayer(false);
            }
          }if(this.map.hasLayer(layer) && !visible && !this.dangerVisible && layer.options.key.includes('Danger') && !layer.options.key.includes('Extreme')){
            this.map.removeLayer(layer);
            if(this.activeLayers){
            this.activeLayers[layer.options.key] = false;
            }
            layer.options.visible = false;
            if(layer.options.hasOwnProperty('emitFromLayerControl') && layer.options.emitFromLayerControl){
              this.utilsService.setIsVisibleOfClusterLayer(false);
            }
          }if(this.map.hasLayer(layer) && !visible && !this.extremeVisible && layer.options.key.includes('Extreme')){
            this.map.removeLayer(layer);
            if(this.activeLayers){
            this.activeLayers[layer.options.key] = false;
            }
            layer.options.visible = false;
            if(layer.options.hasOwnProperty('emitFromLayerControl') && layer.options.emitFromLayerControl){
              this.utilsService.setIsVisibleOfClusterLayer(false);
            }
          }if(this.map.hasLayer(layer) && visible && this.normalVisible && layer.options.key.includes('Normal')){
            this.map.addLayer(layer);
            if(this.activeLayers){
              this.activeLayers[layer.options.key] = true;
            }
            layer.options.visible = true;
            if(layer.options.hasOwnProperty('emitFromLayerControl') && layer.options.emitFromLayerControl){
              this.utilsService.setIsVisibleOfClusterLayer(true);
            }
          }
           if(this.map.hasLayer(layer) && visible && this.cautionVisible && layer.options.key.includes('Caution')){
            this.map.addLayer(layer);
            if(this.activeLayers){
              this.activeLayers[layer.options.key] = true;
            }
            layer.options.visible = true;
            if(layer.options.hasOwnProperty('emitFromLayerControl') && layer.options.emitFromLayerControl){
              this.utilsService.setIsVisibleOfClusterLayer(true);
            }
          } if(this.map.hasLayer(layer) && !visible && this.warningVisible && layer.options.key.includes('Warning')){
            this.map.addLayer(layer);
            if(this.activeLayers){
              this.activeLayers[layer.options.key] = true;
            }
            layer.options.visible = true;
            if(layer.options.hasOwnProperty('emitFromLayerControl') && layer.options.emitFromLayerControl){
              this.utilsService.setIsVisibleOfClusterLayer(true);
            }
          } if(this.map.hasLayer(layer) && visible && this.dangerVisible && layer.options.key.includes('Danger') && !layer.options.key.includes('Extreme')){
            this.map.addLayer(layer);
            if(this.activeLayers){
              this.activeLayers[layer.options.key] = true;
            }
            layer.options.visible = true;
            if(layer.options.hasOwnProperty('emitFromLayerControl') && layer.options.emitFromLayerControl){
              this.utilsService.setIsVisibleOfClusterLayer(true);
            }
          }
          if(this.map.hasLayer(layer) && visible && this.extremeVisible && layer.options.key.includes('Extreme')){
            this.map.addLayer(layer);
            if(this.activeLayers){
              this.activeLayers[layer.options.key] = true;
            }
            layer.options.visible = true;
            if(layer.options.hasOwnProperty('emitFromLayerControl') && layer.options.emitFromLayerControl){
              this.utilsService.setIsVisibleOfClusterLayer(true);
            }
          }
          else{
            if(!is_deselect){
              this.map.addLayer(layer);
              if(this.activeLayers){
                this.activeLayers[layer.options.key] = true;
              }
              layer.options.visible = true;
              if(layer.options.hasOwnProperty('emitFromLayerControl') && layer.options.emitFromLayerControl){
                this.utilsService.setIsVisibleOfClusterLayer(true);
              }
            }
          }
        }
      }
      if(this.params && this.params['component']){
        this.manageLegend();
      }

    }

    toggleLayerList() {
      this.isLayerListClick = !this.isLayerListClick
    }
}
